export const locale = {
  a: "STOCQ Back Office System",
  action: "Action",
  adjusted: "Adjusted",
  xAdjustments: "{0}x Adjustments",
  actionNeeded: "Action Needed",
  tagAccountability: "Tag Accountability",
  tagAccountable: "Tag Accountable",
  accountablePerson: "Accountable Person",
  accountableEmployee: "Accountable Employee",
  amountShouldered: "Amount Shouldered",
  selectEmployee: "Select Employee",
  employeesSelected: "Employee/s selected",
  allEmployees: "All employees",
  splitEvenly: "Split Evenly",
  fullyAccountedFor: "Fully Accounted For",
  shortfallAmount: "Shortfall: {0}",
  overAmount: "Over: {0}",
  untagged: "Untagged",
  balance: "Balance",
  accountabilitySuccessfullyTagged: "Accountability successfully tagged.",
  errorWhileTaggingAccountability: "Error while tagging accountability",
  actualBeginningInventory: "Actual Beginning Inventory",
  actualCashOnHand: "Actual Cash on Hand",
  actualEndingInventory: "Actual Ending Inventory",
  add: "Add",
  addBankDeposit: "Add Bank Deposit",
  addEmployee: "Add Employee",
  addExpense: "Add Expense",
  addKeyAccount: "Add Key Account Collection",
  addRemarks: "Add Remarks",
  agency: "Agency",
  all: "All",
  allCashiers: "All Cashiers",
  allFuelProducts: "All Fuel Products",
  allShits: "All Shifts",
  amount: "Amount",
  amountDeposited: "Amount Deposited",
  amountToShoulder: "Amount to Shoulder",
  applyFilters: "Apply Filters",
  approvedBy: "Approved By",
  arrangeBy: "Arrange By",
  back: "Back",
  backToHomePage: "Back to Home Page",
  bankDeposit: "Bank Deposit",
  bankDepositLogs: "Bank Deposit Logs",
  bankDepositSlip: "Bank Deposit Slip",
  bankDepositSuccess: "Bank Deposit Success",
  bankDepositSuccessMessage: "Your bank deposit of {0} has been successful",
  bankDeposits: "Bank Deposits",
  beginning: "Beginning",
  beginningAccumulatedGrossSales: "Beginning Accumulated Gross Sales",
  beginningAccumulatedSalesInvoice: "Beginning Accumulated Sales Invoice",
  beginningBalance: "Beginning Balance",
  beginningInventory: "Beginning Inventory (Dipstick)",
  beginningTotalizer: "Beginning Totalizer",
  beforeReceiving: "Before Receiving (L)",
  beforeReceivingCm: "Before Receiving (mm)",
  beforeReceivingDS: "Before Receiving",
  afterReceivingDS: "After Receiving",
  afterReceiving: "After Receiving",
  birReport: "BIR Report",
  bos: "Back Office System",
  browseYourFile: "Browse Your Files",
  browseYourFiles: "Browse your files",
  cancel: "Cancel",
  card: "Card",
  cashier: "Cashier",
  cash: "Cash",
  cashAndNonCash: "Cash and Non-Cash",
  cashOnHand: "Cash On Hand",
  cashSales: "Cash Sales",
  cashTracking: "Cash Tracking",
  cashTransactions: "Cash Transactions",
  check: "Check",
  clearAll: "Clear All",
  closed: "Closed",
  closeShift: "Close Shift",
  reopenShift: "Reopen Shift",
  reopenShiftContent:
    "This shift will be reopened and can be edited again. Do you want to proceed?",
  reopenShiftSuccessContent: "The shift has been reopened successfully.",
  reopen: "Reopen",
  coins: "Coins",
  collectionDate: "Collection Date",
  collectionDateAndTime: "Collection Date and Time",
  collectionId: "Collection ID",
  confirm: "Confirm",
  consumableFund: "Consumable Fund",
  coveredDatesAndShifts: "Covered Dates and Shifts",
  creditCard: "Credit Card",
  crewOnDuty: "Crew On Duty",
  currentShift: "Current Shift",
  customerId: "Customer ID",
  customerName: "Customer Name",
  customerRefundableDeposit: "Customer Refundable Deposit",
  customerType: "Customer Type",
  date: "Date",
  dateAndTime: "Date and Time",
  dateAndTimeIn: "Date and Time In",
  dateAndTimeOut: "Date and Time Out",
  dateBy: "Date By",
  deactivate: "Deactivate",
  default: "Default",
  delivery: "Delivery",
  deliveryId: "Delivery ID",
  denomination: "Denomination",
  depositDate: "Deposit Date",
  depositDateAndTime: "Deposit Date and Time",
  depositID: "Deposit ID",
  depositId: "Deposit ID",
  depositType: "Deposit Type",
  description: "Description",
  diesel: "Diesel",
  didNotPerformDipstickReading: "Did not perform dipstick reading",
  discount: "Discount",
  discountAmount: "Discount Amount",
  discountReport: "Discount Report",
  discountPremium: "Discount/Premium",
  discounts: "Discounts",
  driverLicenseIdIsInvalid: "This driver license ID is invalid.",
  dryStockDeliveries: "Dry Stock Deliveries",
  dryStockInventory: "Dry Stock Inventory",
  dryStockMovement: "Dry Stock Movement",
  dryStockSales: "Dry Stock Sales",
  edit: "Edit",
  editBankDeposit: "Edit Bank Deposit",
  editDetails: "Edit details",
  email: "Email",
  emailAddress: "Email Address",
  employee: "Employee",
  employeeAssigned: "Employee Assigned",
  employeeOnDuty: "Employee on Duty",
  employeePosition: "Employee Position",
  employeeToShoulderShortage: "Employee to Shoulder Shortage",
  endOfShift: "End of Shift",
  endShift: "Shift End Date & Time",
  ending: "Ending",
  endingAccumulatedGrossSales: "Ending Accumulated Gross Sales",
  endingAccumulatedSalesInvoice: "Ending Accumulated Sales Invoice",
  endingInventory: "Ending Inventory (Dipstick)",
  endingTotalizer: "Ending Totalizer",
  enterEmployeeOnDuty: "Enter employee on duty",
  enterKeyAccountCode: "Enter key account code",
  enterKeyAccountName: "Enter key account name",
  enterReferenceNumber: "Enter reference number",
  enterRemarks: "Enter remarks",
  enterSiNumSoa: "Enter SI Number / SOA",
  expense: "Expense",
  expenseAddedSuccessfully: "Expense Added Successfully",
  expenseConfirmMessage:
    "You are about to add expense amounting to {0} {1}. Proceed with adding expense?",
  keyAccountCollectionConfirmMessage:
    "You are about to add a key account collection amounting to <br> {0}. Proceed with adding collection?",
  expenseDate: "Expense Date",
  expenseDateAndTime: "Expense Date and Time",
  expenseId: "Expense ID",
  expenseLogs: "Expense Logs",
  expenseType: "Expense Type",
  expenses: "Expenses",
  expensesSubmitted: "Expenses Submitted",
  expired: "Expired",
  export: "Export",
  exclamatedSuccess: "Success!",
  excess: "Excess",
  expectedCashOnHand: "Expected Cash on Hand",
  expectedEndingInventory: "Expected Ending Inventory",
  failedToUploadImage: "Failed to upload image. The format is not supported.",
  forceClose: "Force Close",
  forceCloseShift: "Force Close Shift",
  forceCloseSyncWarning:
    "Sync is not complete. Force closing this shift may result in incomplete data. Please provide a reason to proceed.",
  closeShiftConfirmation: "Are you sure you want to close this shift?",
  finalAmount: "Final Amount",
  finalAmountPaid: "Final Amount Paid",
  fileTooLarge: "File too large.",
  filters: "Filters",
  fuelAndLubesSales: "Fuel and Lubes Sales",
  fuelDeliveries: "Fuel Deliveries",
  fuelSales: "Fuel Sales",
  fuelVariance: "Fuel Variance",
  gas91: "Gas 91",
  gas95: "Gas 95",
  gas97: "Gas 97",
  goToLogin: "Go to Login",
  gotIt: "Got It",
  grossAmount: "Gross Amount",
  grossSales: "Gross Sales",
  grossTotal: "Gross Total",
  imageErrorContent: "Please upload a valid image file in JPEG or PNG format, no larger than 5MB.",
  imageUploadFailed: "Image upload failed",
  incorrectEmailOrPassword: "Incorrect email or password. Please try again.",
  invoice: "Invoice",
  invoiceNo: "Invoice No.",
  invalidDimensions: "Image dimensions must be less than 100px.",
  invalidFileType: "Invalid file type.",
  invalidImage: "The selected file is not a valid image.",
  keyAccount: "Key Account",
  keyAccountCollection: "Key Account Collection",
  keyAccountCollections: "Key Account Collections",
  keyAccountCollectionsLogs: "Key Account Collection Logs",
  keyAccountCollectionsSubmitted: "Key Account Collection Submitted",
  keyAccountCode: "Key Account Code",
  keyAccountName: "Key Account Name",
  keyAccountPayments: "Key Account Payments",
  keyAccountSubmitted: "Key Account Collection Submitted",
  keyword: "Keyword",
  lastEdited: "Last edited on ",
  logIn: "Log In",
  logout: "Logout",
  lubricantSales: "Lubricants Sales",
  lubeserv: "Lubeserv",
  markAsStraightDuty: "Mark as Straight Duty",
  maxFileSize5MB: "Choose a file or drag and drop. PNG, JPG and JPEG formats, up to 5 MB.",
  maxLimitToUploadReached: "Maximum limit to upload a file reached",
  maxLiterShouldBe: "Maximum value should be {0}",
  maximumDigitsAndDecimalPlaces: "Maximum of {0} digits and 2 decimal places.",
  name: "Name",
  netCashSummary: "Net Cash Summary",
  netTotal: "Net Total",
  newSafeDropBalance: "New Safe Drop Balance",
  nonCashSummary: "Non-Cash Summary",
  nonCashTransactions: "Non-Cash Transactions",
  nonSaleTransactions: "Non-Sale Transactions",
  noOfTransactions: "No. of Transactions",
  ohSnap: "Oh snap!",
  okayGotIt: "Okay, got it!",
  onlyAlphaNumericAllowedAndSpecial:
    "Only Alphanumeric characters and the following special symbol ( - , . , spaces ) are allowed.",
  onlyEndedShifts:
    "Only ended shifts that are 100% synced can be closed. Please ask the cashier to complete sync from the Stocq app.",
  onlyNumericAreAllowed: "Only numeric characters are allowed.",
  oops: "Oops! Something went wrong",
  otherDiscounts: "Other Discounts",
  password: "Password",
  pay: "Pay",
  paymentMethod: "Payment Method",
  plateNumber: "Plate Number",
  pleaseEnterAValidEmailAddress: "Please enter a valid email address.",
  pleaseEnterAValidMobileNumber: "Please enter a valid mobile number.",
  pleaseEnterAValidTelephoneNumber: "Please enter a valid telephone number.",
  pleaseRefreshYourBrowser: "Please refresh your browser",
  pleaseSelectCSVFile: "Please select a .csv file",
  pleaseTryADifferentOne: "Please try a different one.",
  poReferenceNumber: "PO Reference Number",
  prevShiftNotClosed: "Previous Shift Not Closed",
  premium: "Premium",
  proceed: "Proceed",
  product: "Product",
  productCategory: "Product Category",
  productDescription: "Product Description",
  promoName: "Promo Name",
  promoSummary: "Promo Summary",
  pump: "Pump",
  pumpCalibration: "Pump Calibration",
  pumpDiscount: "Pump Discount",
  pumpError: "Pump Error",
  pumpNo: "Pump No.",
  pumpNumber: "Pump Number",
  pumpPrice: "Pump Price",
  pwdDiscount: "PWD Discount",
  qty: "QTY",
  qtySold: "Qty Sold",
  quantity: "Quantity",
  quantityDelivered: "Quantity Delivered",
  quantitySold: "Quantity Sold",
  reason: "Reason",
  receipt: "Receipt",
  recordedVolume: "Recorded Volume",
  records: "Records",
  refName: "Ref Name",
  referenceInvoice: "Reference Invoice",
  referenceNo: "Reference No.",
  referenceNumber: "Reference Number",
  referenceSalesInvoiceNo: "Reference Sales Invoice No.",
  refund: "Refund",
  refundTransactionReport: "Refund Transaction Report",
  rememberMe: "Remember Me",
  remarks: "Remarks",
  replace: "Replace",
  revolvingFund: "Revolving Fund",
  returns: "Returns",
  return: "Return",
  safeDrops: "Safe Drops",
  sales: "Sales",
  salesAndInventory: "Sales and Inventory",
  salesCount: "Sales Count",
  salesDiscount: "Sales Discount",
  salesInvoiceNo: "Sales Invoice No.",
  salesPremium: "Sales Premium",
  salesSummaryReport: "Sales Summary Report",
  salesTransactioHistoryReport: "Sales Transaction History Report",
  sampleRemarks: "Sample Remarks",
  save: "Save",
  saveChanges: "Save Changes",
  searchOrSelect: "Search or select",
  selectAgency: "Select agency",
  selectDepositType: "Select deposit type",
  selectExpenseType: "Select expense type",
  selectKeyAccountCode: "Select Key Account Code",
  selectKeyAccountName: "Select Key Account Name",
  selectPosition: "Select position",
  selectPaymentMethod: "Select payment method",
  selectPaymentType: "Select payment type",
  selectShift: "Select shift",
  selectStations: "Select Stations",
  seniorDiscount: "Senior Discount",
  setTime: "Set Time",
  shift: "Shift",
  shiftAttendance: "Shift Attendance",
  shiftDate: "Shift Date",
  shiftDateAndTime: "Shift Date and Time",
  shiftDetails: "Shift Details",
  shiftNumber: "Shift Number",
  shiftRecords: "Shift Records",
  shiftReportDetails: "Shift Report Details",
  shiftStatus: "Shift Status",
  shiftSyncRequired: "Shift Sync Required",
  siNumSoa: "SI Number / SOA",
  sku: "SKU",
  sorryNoResultFound: "Sorry, no results found",
  specialRequest: "Special Request",
  started: "Started",
  ended: "Ended",
  startShift: "Shift Start Date & Time",
  straightDuty: "Straight Duty",
  status: "Status",
  stocqBOS: "STOCQ Back Office System",
  submit: "Submit",
  successMessageModalCloseShift: "You have successfully ended your shift",
  somethingWentWrongPleaseTryAgain: "Something went wrong. Please try again.",
  switchStations: "Switch Stations",
  syncProgress: "Sync Progress",
  thisShiftCannotBeEdited:
    "This shift cannot be edited because an earlier shift is still open. Please ensure that all prior shifts are closed before editing details.",
  time: "Time",
  to: "to",
  total: "Total",
  totalAmount: "Total Amount",
  totalAmountDue: "Total Amount Due",
  totalDiscount: "Total Discount",
  totalFuelSales: "Total Fuel Sales",
  totalSales: "Total Sales",
  totalizerDifference: "Totalizer Difference",
  totalizerVariance: "Totalizer Variance (%)",
  transactionCount: "Transaction Count",
  transactionId: "Transaction ID",
  transactionNo: "Transaction No.",
  transactionType: "Transaction Type",
  transient: "Transient",
  tryAgain: "Try Again",
  type: "Type",
  typeOfExpense: "Type of Expense",
  typeYourRemarks: "Type your remarks here",
  ugt: "UGT",
  unitPrice: "Unit Price",
  uploadImage: "Upload Image",
  use8CharWithMix: "Use 8 or more characters with a mix of letters, numbers and symbols",
  valueShouldNotBe: "Value should not be {0}",
  valueShouldBeHigher: "Value should be higher than {0}.",
  variant: "Variant",
  variance: "Variance",
  vatAmount: "VAT Amount",
  vatExempt: "VAT Exempt",
  vatSales: "VATable Sales",
  vatableSales: "VATable Sales",
  viewDetails: "View Details",
  viewRemarks: "View Remarks",
  voidReport: "Void Report",
  volumeSold: "Volume Sold",
  weCouldNotFindAMatchForSearchCriteria: "We could not find a match for your search criteria.",
  wetStockInventory: "Wet Stock Inventory",
  witnesses: "Witnesses",
  youHaveSuccessfullyAddedAnExpense: "You have successfully submitted these expenses.",
  youHaveSuccessfullySubmittedCollection:
    "You have successfully submitted this key account collection.",
  zeroRatedSales: "Zero Rated Sales",
  zReadCount: "Z-Read Counter",
  lpgSales: "LPG Sales",
  actions: "Actions",
  quantityBeforeReceiving: "Quantity Before Receiving",
  quantityAfterReceiving: "Quantity After Receiving",
  category: "Category",
  selectProducts: "Select Products",
  productDetails: "Product Details",
  productType: "Product Type",
  fuel: "Fuel",
  lubricants: "Lubricants",
  addProduct: "Add Product",
  deliveryInformation: "Delivery Information",
  witness: "Witness",
  enterName: "Enter name",
  position: "Position",
  select: "Select",
  witnessInformation: "Witness Information",
  addWitness: "Add Witness",
  deliveryRecipient: "Delivery Recipient",
  addDeliveryLog: "Add Delivery Log",
  inventory: "Inventory",
  deliveryLogs: "Delivery Logs",
  changeProductType: "Change Product Type",
  confirmChangeProductType:
    "Product details that have been entered will be discarded. Proceed with changing product type?",
  no: "No",
  yes: "Yes",
  productName: "Product Name",
  defaultPrice: "Default Price",
  overridePrice: "Override Price",
  nSelected: "{0} Selected",
  deliveryDateAndTime: "Delivery Date and Time",
  viewAttachment: "View Attachment",
  filterDateBy: "Filter Date By",
  deliveryDate: "Delivery Date",
  deliveryTime: "Delivery Time",
  addDeliverLog: "Add Delivery Log",
  form2307: "Form 2307",
  water: "Water",
  internet: "Internet",
  electricity: "Electricity",
  electricityGeneratorSet: "Electricity-generator set",
  loadAllowance: "Load Allowance",
  postage: "Postage",
  transportation: "Transportation",
  officeSupplies: "Office Supplies",
  photocopy: "Photocopy",
  otherSupplies: "Other Supplies",
  promoAdvertising: "Promo & Advertising",
  permitsLicensesTaxes: "Permits, Licenses and Taxes",
  stationProgramExpense: "Station Program Expense",
  maintenanceRepairs: "Maintenance & Repairs",
  mealAllowance: "Meal Allowance",
  bankCharges: "Bank Charges",
  lubesIncentives: "Lubes Incentives",
  accommodation: "Accommodation",
  nonInventoryItemRebates: "Non-inventory item-rebates",
  nonInventoryItemIndexCard: "Non-inventory item-index card",
  confirmSaveDeliveryLog: "Are you sure you want to save this delivery log?",
  close: "Close",
  deliveryLogAdded: "Delivery Log Added",
  deliveryLogAddedMessage: "You have successfully added a delivery log.",
  editDeliveryLog: "Edit Delivery Log",
  deliveryLogUpdated: "Delivery Log Saved",
  deliveryLogUpdatedMessage: "The delivery log has been saved successfully.",
  saveDeliveryLog: "Save Delivery Log",
  deliveryLogRecorded: "Delivery Log Recorded",
  deliveryLogRecordedMessage: "You have successfully recorded the delivery.",
  selectProductType: "Select product type",
  afterReceivingCm: "After Receiving (mm)",
  afterReceivingL: "After Receiving (L)",
  receiptPreview: "Receipt",
  view: "View",
  noReceipt: "No Receipt",
  slipPreview: "Bank Slip",
  noDepositSlip: "No Deposit Slip",
  rebateType: "Rebate Type",
  selectRebateType: "Select Rebate Type",
  vipToCash: "VIP to Cash",
  todaOrJodaRebates: "TODA/JODA Rebates",
  permitsLicensesTaxesWithoutComma: "Permits Licenses and Taxes",
  purchaseOrder: "Purchase Order",
  createOrder: "Create Order",
  orderId: "Order ID",
  purchaseOrderNo: "Purchase Order No.",
  salesOrderNo: "Sales Order No.",
  processing: "Processing",
  forApproval: "For Approval",
  forRevision: "For Revision",
  cancelled: "Cancelled",
  rejected: "Rejected",
  forDelivery: "For Delivery",
  delivered: "Delivered",
  status: "Status",
  orderDateAndTime: "Order Date/Time",
  products: "Products",
  amountInKL: "Amount in kL",
  amountInPhp: "Amount in Php",
  shiftDuration: "Shift Duration",
  regularDiscount: "Regular Discount",
  orderRecipient: "Order Recipient",
  preferredDeliveryDateTime: "Preferred Delivery Date and Time",
  placeOrder: "Place Order",
  itemOrder: "Item Order",
  currentInventoryLevel: "Current Inventory Level",
  orderedVolume: "Order Volume",
  purchaseOrderAdded: "Purchased Order Added",
  purchaseOrderAddedMessage: "You have successfully added a purchase order.",
  editPurchaseOrder: "Edit Purchase Order",
  purchaseOrderUpdated: "Purchase Order Saved",
  purchaseOrderUpdatedMessage: "The purchase order has been saved successfully.",
  savePurchaseOrder: "Save Purchase Order",
  purchaseOrderRecorded: "Purchase Order Recorded",
  purchaseOrderRecordedMessage: "You have successfully recorded the purchase order.",
  addPurchaseOrder: "Add Purchase Order",
  confirmSavePurchaseOrder: "Are you sure you want to save this purchase order?",
  orderDetails: "Order Details",
  updatePurchaseOrderID: "Update Order ID",
  purchaseOrderNo: "Purchase Order No.",
  salesOrderNo: "Sales Order No.",
  headOfficeRemarks: "Head Office Remarks",
  cancelAnyway: "Cancel Anyway",
  goBack: "Go Back",
  cancelOrder: "Cancel Order",
  areYouSureYouWantToCancelThisPurchaseOrder:
    "Are you sure you want to cancel this Purchase Order?",
  purchaseOrderCancelled: "Purchase Order Cancelled",
  thePurchaseOrderHasBeenCancelled: "The purchase order has been successfully cancelled.",
  rejectReason: "Reject Reason",
  revisionRequestReason: "Revision Request Reason",
  kl: "KL",
  cancel: "Cancel",
  cancelPurchaseOrder: "Cancel Purchase Order?",
  updatePurchaseOrder: "Update Purchased Order",
  purchaseOrderUpdatedMessage: "Your changes have been successfully saved.",
  saveChangesQuestion: "Save Changes?",
  areYouSureYouWantToSaveTheChangesMade: "Are you sure you want to save the changes you made?",
  continueEditing: "Continue editing",
  placePurchaseOrder: "Place Purchase Order",
  canceled: "Canceled",
  thisUpdateWillOnlyApplyinBOS:
    "This update will only apply in BOS and will not affect the Beginning Balance in POS reports (Z-Reading/X-Reading)",
  typeYourRemarksHere: "Type your remarks here",
  areYouSureYouWantToUpdateBeginningBalance:
    "Are you sure you want to update the Beginning Balance?",
  successMessageModalBeginningBalance: "You have successfully updated the Beginning Balance.",
  updateBeginningBalance: "Update Beginning Balance",
  errorWhileUpdatingBeginningBalance: "Error while updating Beginning Balance",
  inventoryText:
    "Displayed value is derived from totalizer liters sold. No dipstick reading recorded for the current date.",
  thisReferenceNumberAppearsInOtherRows: "This Reference Number appears in {0} other rows.",
  doYouWantToUpdateAllInstancesOfThisReferenceNumber:
    "Do you want to update all instances of this Reference Number?",
  errorWhileUpdatingReferenceNumber: "Error while updating Reference Number",
  updateReferenceNumber: "Update Reference Number",
  successMessageModalReferenceNumber: "You have successfully updated the Reference Number.",
  edited: "Edited",
  thisReferenceNumberHasChangedFrom: "This reference number has changed from {0} to {1}.",
  reminder: "Reminder",
  changesWillTakeEffectAfterThisShiftIsClosed:
    "Changes will take effect after this shift is closed.",
  detailedTransactionHistory: "Detailed Transaction History",
  paymentReferenceNumber: "Payment Reference No.",
  paymentReferenceName: "Payment Reference Name",
  stationCode: "Station Code",
  shiftDateandTime: "Shift Date & Time",
  salesInvoiceNumber: "Sales Invoice Number",
  transactionDateAndTime: "Transaction Date & Time",
  paymentReferenceNumberAndName: "Payment Reference Number & Name",
  totalizerReading: "Totalizer Reading",
  pricePerItem: "Price per Item",
  totalGrossAmount: "Total Gross Amount",
  transactionDate: "Transaction Date",
  detailedTransactionHistoryReport: "Detailed Transaction History Report",
  viewAll: "View All",
  adjustmentTotal: "Adjustment Total",
  editRemarks: "Edit Remarks",
  sampleRemarksHere: "Sample remarks here",
  itemCode: "Item Code",
  ok: "Ok",
  reminderToastMessageGiftCard:
    "Any changes to the reference number will take effect immediately after saving. Please ensure the new reference number is correct before proceeding.",
  cannotCloseShift: "Cannot Close Shift",
  requiredFieldsStillNeedToBeFilledIn: "{0} required fields still need to be filled in.",
  oneRequiredFieldStillNeedsToBeFilledIn: "1 required field still needs to be filled in.",
  fieldsRemaining: "{0} fields remaining",
  oneFieldRemaining: "1 field remaining",
  allFieldsComplete: "All fields complete.",
  clickToHighlightEmptyOrInvalidInputFields: "Click to highlight empty or invalid input fields",
  goToNextIncompleteField: "Go to next incomplete field",

  pleaseSelectShiftNumber: "Please select shift number.",
  pleaseSelectShiftDate: "Please select shift date.",
  shiftDateCannotBeAFutureDate: "Shift Date cannot be a future date.",
  pleaseEnterEmployeeOnDuty: "Please enter employee on duty.",
  pleaseEnterAValidEmployeeName: "Please enter a valid name (2-100 letters).",
  pleaseSelectAgency: "Please select agency.",
  pleaseSelectEmployeePosition: "Please select employee position.",
  pleaseSelectDateAndTimeIn: "Please select date and time in.",
  pleaseSelectDateAndTimeOut: "Please select date and time out.",
  dateAndTimeOutMustBeAfterDateAndTimeIn: "Date and time out must be after date and time in.",
  thisFieldIsRequired: "This field is required.",
  pleaseEnterAValidAmount: "Please enter a valid amount.",

  pleaseSelectAnEmployeeToShoulderShortage: "Please select an Employee to Shoulder Shortage.",
  thisEmployeeIsAlreadySelected: "This employee is already selected.",
  totalAmountToShoulderMustCover:
    "Total amount to shoulder must be at least {0} to cover the shortage.",
  currentPaymentMethod: "Current Payment Method",
  newPaymentMethod: "New Payment Method",
  selectPaymentMethod: "Select Payment Method",
  thisChangeWillAlsoApplyToOtherRows:
    "This change will also apply to {0} other row/s with the same transaction no.",
  editTransaction: "Edit Transaction",
  adjustPaymentMethod: "Adjust Payment Method",
  otherRow: "other row",
  bosReportingCorrection: "BOS reporting correction - POS transaction remains as recorded.",
  changesAlsoApplyToOtherRows:
    "Any changes will also apply to the {0} with the same transaction no.",
  paymentMethodChangeUnavailableForSplitPayment:
    "Changing the payment method is not available to split payment or transactions with multiple gift cards.",
  selectPayment: "Select Payment",
  saveAdjustment: "Save Adjustment",
  pleaseEnterAReferenceNumber: "Please enter a Reference Number.",
  successfullyUpdated: "Successfully Updated",
  discardChangesQuestion: "Discard Changes?",
  discardChangesMessage:
    "You have unsaved changes. Are you sure you want to discard your changes?",
  yourChangesHaveBeenSaved: "Your changes have been saved.",
  errorWhileUpdatingPaymentMethod: "Error while updating Payment Method",
  thisPaymentMethodHasChangedFrom: "This payment method has changed from {0} to {1}.",
  reminderToastMessagePaymentMethod:
    "Any changes to the payment method will take effect immediately after saving. The transaction amount and discount stay as they are. Please ensure the new payment method is correct before proceeding.",
};

export default Object.freeze(locale);
